import { render, staticRenderFns } from "./Sidebar.pug?vue&type=template&id=2768521d&lang=pug&external"
import script from "./Sidebar.js?vue&type=script&lang=js&external"
export * from "./Sidebar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports